module.exports = __webpack_public_path__ + "img/radio_button_checked.db241d36.svg";